import { areDescriptionsEqual } from "../helpers";
import { MaterialGradeType } from "../types";

export const areMaterialsEquals = (
  a: {
    name?: string | null | undefined;
    materialGrade?: MaterialGradeType | undefined;
  },
  b: {
    name?: string | null | undefined;
    materialGrade?: MaterialGradeType | undefined;
  },
): boolean => {
  const aName = a.name ?? undefined;
  const bName = b.name ?? undefined;

  if (a.materialGrade !== b.materialGrade) {
    return false;
  }

  if (aName && bName) {
    return areDescriptionsEqual(aName, bName);
  }

  if (!aName && !bName) {
    return true;
  }

  return false;
};
